import type { AnalyticsLot, FavoritesSource, GAEventOptions } from '~/analytics/composables-types'
import { getGlobalPreviewCatalog } from '~/analytics/composables-types'
import type { AmplitudePayloadResult } from '~/analytics/composables-types'
import { getViewProductPageGAOptions } from '~/composables/useViewProductPageAnalytics'
import { appendLotProductOwnerFields } from '~/composables/useLotProductAnalytics'

interface AddToFavoritesAmplitudeParams {
  lot: AnalyticsLot
  productList?: string | number
}

interface AddToFavoritesGAParams {
  lot: AnalyticsLot
  productList?: string | number
}

export function getAddToFavoritesProductList (
  source: FavoritesSource,
  _rootGetters?: Record<string, unknown>,
): string | number {
  if (source === 'CART') {
    return ''
  }
  return getGlobalPreviewCatalog()
}

export function getAddToFavoritesAmplitudePayload ({
  lot,
  productList = '',
}: AddToFavoritesAmplitudeParams): AmplitudePayloadResult {
  const payload: AmplitudePayloadResult = {}

  appendLotProductOwnerFields(payload, {
    lot,
    owner: lot.user,
    productList,
  })

  return payload
}

export function getAddToFavoritesGAOptions ({
  lot,
  productList = '',
}: AddToFavoritesGAParams): GAEventOptions {
  return getViewProductPageGAOptions({ lot, productList })
}
